/* FANNUR v0.5 — font catalog: system, Google Fonts, Shopify theme font_face and custom WOFF2. */
(() => {
  'use strict';
  const baseline = [
    {id:'classic-serif',label:'Classic Serif',family:'Georgia',source:'system'},
    {id:'modern-sans',label:'Modern Sans',family:'Arial',source:'system'},
    {id:'traditional-serif',label:'Traditional Serif',family:'Times New Roman',source:'system'},
    {id:'playfair',label:'Playfair Display',family:'Playfair Display',source:'google',googleFamily:'Playfair Display'},
    {id:'cormorant',label:'Cormorant Garamond',family:'Cormorant Garamond',source:'google',googleFamily:'Cormorant Garamond'},
    {id:'dm-sans',label:'DM Sans',family:'DM Sans',source:'google',googleFamily:'DM Sans'},
    {id:'great-vibes',label:'Great Vibes',family:'Great Vibes',source:'google',googleFamily:'Great Vibes'}
  ];
  const FONT_ID=/^[a-z0-9][a-z0-9_-]{0,49}$/;
  const SAMPLE='FANNUR Lettertypes 1234567890 Àáéëöü';
  function safeRecord(font){
    if(!font||!FONT_ID.test(String(font.id||'')))return null;
    if(typeof font.family!=='string'||!font.family.trim()||font.family.length>100)return null;
    if(typeof font.label!=='string'||!font.label.trim()||font.label.length>100)return null;
    if(!['system','google','css','url'].includes(font.source))return null;
    const rec={...font, family:font.family.trim(),label:font.label.trim()};
    if(rec.source==='url'){
      try{
        const parsed=new URL(rec.url,location.href);
        if(parsed.protocol!=='https:'&&parsed.protocol!=='http:')return null;
        if(!/\.woff2?(?:$|[?#])/i.test(parsed.pathname+parsed.search))return null;
        rec.url=parsed.href;
      }catch{return null;}
    }
    if(rec.source==='google'&&!/^[\p{L}0-9 -]+$/u.test(rec.googleFamily||''))return null;
    return rec;
  }
  function create(custom=[]){
    const all=new Map(baseline.map(font=>[font.id,font]));
    for(const raw of (Array.isArray(custom)?custom:[])){
      const item=safeRecord(raw);if(item)all.set(item.id,item);
    }
    const loaded=new Map();
    const googleLinks=new Map();
    async function load(fontId){
      const font=all.get(fontId);
      if(!font)throw Error(window.FANNUR_I18N?.t('errorFont')||'This font is unavailable.');
      if(loaded.has(fontId))return loaded.get(fontId);
      const pending=(async()=>{
        if(font.source==='system')return font;
        if(font.source==='url'){
          if(typeof FontFace!=='function')throw Error(window.FANNUR_I18N?.t('errorBrowser')||'Your browser is not supported.');
          const escaped=font.url.replaceAll('"','%22').replaceAll('\\','%5C');
          const face=new FontFace(font.family,`url("${escaped}") format("woff2")`,{weight:String(font.weight||'400'),style:String(font.style||'normal'),display:'swap'});
          await face.load();document.fonts.add(face);
          return font;
        }
        if(font.source==='google'){
          let promise=googleLinks.get(font.id);
          if(!promise){
            const family=encodeURIComponent(font.googleFamily||font.family).replaceAll('%20','+');
            const url=`https://fonts.googleapis.com/css2?family=${family}&display=swap`;
            promise=new Promise((resolve,reject)=>{
              const link=document.createElement('link');link.rel='stylesheet';link.href=url;
              link.onload=resolve;link.onerror=()=>reject(Error('Google Fonts kon niet worden geladen.'));
              document.head.appendChild(link);
            });
            googleLinks.set(font.id,promise);
          }
          await promise;
        }
        if(!document.fonts?.load)throw Error(window.FANNUR_I18N?.t('errorFont')||'This font is unavailable.');
        await document.fonts.load(`32px "${font.family.replaceAll('"','')}"`,SAMPLE);
        // Browser font load() kan bij ontbrekende fonts stilletjes naar systeemfonts terugvallen.
        // Controleer dat een geladen webfont met deze family bekend is.
        const registered=[...document.fonts].some(face=>face.family.replaceAll(/["']/g,'').toLowerCase()===font.family.toLowerCase() && face.status==='loaded');
        if(!registered)throw Error(window.FANNUR_I18N?.t('errorFont')||'This font is unavailable.');
        return font;
      })();
      loaded.set(fontId,pending);
      try{return await pending;}catch(err){loaded.delete(fontId);throw err;}
    }
    const list=ids=>ids.filter(id=>all.has(id)).map(id=>all.get(id));
    return {load,list,get:id=>all.get(id),all:()=>[...all.values()]};
  }
  window.FANNUR_FONTS_V05={create,baseline};
})();
